export default __webpack_public_path__ + "static/media/bibooScreen.dcf99411.png";